import { ErrorMessage } from "@msys/ui";
import { useTranslate } from "@tolgee/react";

export const PageNotFound = () => {
  const { t } = useTranslate("PageNotFound");

  return <ErrorMessage message={t("Page Not Found")} />;
};
